export let ContrastRatioLevel = /*#__PURE__*/function (ContrastRatioLevel) {
  ContrastRatioLevel["Fail"] = "fail";
  ContrastRatioLevel["AA"] = "AA";
  ContrastRatioLevel["AAA"] = "AAA";
  return ContrastRatioLevel;
}({});
//# sourceMappingURL=types.js.map